import React, {useEffect, useState} from 'react';
import {DebounceInput} from 'react-debounce-input';
import SearchIcon from 'assets/svgs/common/search.svg';
import CloseIcon from 'assets/svgs/actions/close.svg';
import DownloadIcon from 'assets/svgs/file-upload/upload.svg';
import Breadcrumb from './BreadCrumb';
import messages from './messages';

const Search = ({
  onFile,
  breadcrumb,
  tab = {label: 'Images'},
  onClick,
  onChange,
  searchKey,
  setSearchKey,
  selected,
}) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!loaded) return;

    onChange(searchKey);
  }, [searchKey]);

  useState(() => {
    setTimeout(() => {
      setLoaded(true);
    }, 1000);
  }, []);

  return (
    <div className="search-profiles file-search d-flex align-items-center py-4">
      {tab && (
        <Breadcrumb
          tab={tab}
          list={breadcrumb}
          onClick={(folder) => {
            onClick(folder);
          }}
        />
      )}

      <div
        className={`search-bar-pro position-relative ${
          breadcrumb.length === 0 ? 'w-100' : ''
        }`}
      >
        <span className="icon-search">
          <img alt="Search" src={SearchIcon} />
        </span>
        <DebounceInput
          minLength={1}
          placeholder={messages.companySearchPlaceholder}
          value={searchKey}
          debounceTimeout={100}
          onChange={(event) => setSearchKey(event.target.value)}
        />
        {searchKey && (
          <button
            type="button"
            className="close-search btn-link"
            onClick={() => {
              setSearchKey('');
            }}
          >
            <img alt="" src={CloseIcon} />
          </button>
        )}
      </div>
      {selected && selected._id && (
        <button
          type="button"
          onClick={onFile}
          className="add-btn bg-gray4 add-new-blog btn-upload d-flex py-2 justify-content-center ml-3"
        >
          <img src={DownloadIcon} alt="upload" className="mr-2" />
          {messages.upload}
        </button>
      )}
    </div>
  );
};
export default Search;
